
  import {Component, Ref, Vue, Watch} from "vue-property-decorator";
  import {ElForm} from "element-ui/types/form";
  import api from "@/api";
  import {ChangeStoreToNewPartialAreaInput, CreateOrEditDepartmentDto, OrganizationUnitLevel} from "@/api/appService";
  import {SelectListItem} from "@/core/common-type-definitions";

  @Component({name:'ChangeStoreToNewPartialArea'})
  export default class ChangeStoreToNewPartialArea extends Vue {
    @Ref() readonly dataForm!: ElForm;

    storeId:number = 0;

    partialAreaList:SelectListItem<string>[] = []

    formData:ChangeStoreToNewPartialAreaInput = {
      storeId:0,
      partialAreaId:undefined
    }

    created(){
      this.fetchOrganizationUnits();
    }

    @Watch('storeId')
    onStoreIdChange(){
      this.formData.storeId = this.storeId;
    }

    fetchOrganizationUnits(){
      api.organizationUnit.getOrganizationUnitsOfDescendantBySession().then(res=>{
        this.partialAreaList = res.filter(s=>s.level === OrganizationUnitLevel.片区)
                                  .map(org=>{
                                    return {value:org.id!.toString(),label:org.displayName} as SelectListItem<string>
                                  });
      });
    }


    @Watch("show")
    async onShowChange(value: boolean) {
      if(value === false){
        this.formData.partialAreaId = undefined;
      }
    }

    defaultData: CreateOrEditDepartmentDto = {
      displayName: undefined,
      desc: undefined,
      parentId: undefined,
      id: 0
    };

    show = false;
    form: CreateOrEditDepartmentDto = { ...this.defaultData };

    async save() {
      if(!this.formData.partialAreaId){
        this.$message.error('请选择片区');
        return ;
      }
      api.organizationUnit.changeStoreToNewPartialArea({body:this.formData}).then(res=>{
        this.$message.success('变更成功');
        this.show = false;
        this.$emit('change-completed');
      })
    }

    cancel() {
      this.show = false;
    }
  }
